import { BookService } from 'src/app/api/book.service';
import { Component, ViewChild, EventEmitter, Output, OnInit, AfterViewInit, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { } from 'googlemaps';

@Component({
    selector: 'AutocompleteComponent',
    templateUrl: './autocomplete-component.component.html',
    styleUrls: ['./autocomplete-component.component.scss'],
})
export class AutocompleteComponent implements OnInit, AfterViewInit {
    @Input() adressType: string;
    @Output() setAddress: EventEmitter<any> = new EventEmitter();
    @ViewChild('addresstext') addresstext: any;

    autocompleteInput: string;
    queryWait: boolean;

    constructor(private bookService: BookService ) {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.getPlaceAutocomplete();
    }

    private getPlaceAutocomplete() {
        const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
            {
                componentRestrictions: { country: 'FR' },
                types: [this.adressType]  // 'establishment' / 'address' / 'geocode'
            });
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            const place = autocomplete.getPlace();
             let event = {lat: place.geometry.location.lat(),lng: place.geometry.location.lng()}
            this.invokeEvent(place);
            this.sendGps(event)
            // console.log([place.geometry.location.lat(), place.geometry.location.lng()])
        });
    }

    invokeEvent(place) {
        
        this.setAddress.emit([place.geometry.location.lat(), place.geometry.location.lng()]);
    }

    sendGps(data ){
    this.bookService.publish(data);
    }

}